import { useState } from 'react'
import { InputDinamycPlaceholder } from "@lk-gtcom/ecomlab-components"
import { ButtonBasic } from "@lk-gtcom/ecomlab-components";
import { ModalComponent } from '../ModalComponent/ModalComponent';
import './ModalNewTaskList.scss'

export const ModalNewTaskList = ({ add, close }) => {
    const [name, setName] = useState("")

    return (
        <ModalComponent
            onClose={close}
            title='Добавить колонку'
            style={{
                maxWidth: '500px',
                height: 'auto'
            }}
            child={
                <div className='modal-new-task-list'>
                    <InputDinamycPlaceholder
                        placeholder='Название'
                        type='text'
                        onChange={setName}
                        autoFocus
                        size='s'
                    />
                    <ButtonBasic
                        green
                        text='Создать'
                        onClick={() => {
                            add(name)
                            close()
                        }}
                    />
                </div>
            }
        />
    )
}